<template>
 
</template>

<script>

// modules
import { mapState } from 'vuex'
// services

import db from '@/services/db'

export default {
  components: {
    
  },
  data () {
    return {
      activeForm: 1,
      customLogo: null,
      logoLoaded: false
    }
  },
  computed: {
    ...mapState([
      'userId'
    ])
  },
  methods: {
    
  },
  created: function () {
    // `this` points to the vm instance
    console.log('set users workspace')
    console.log(this.fbUser)
    localStorage.lastDash = this.$route.params.dashid
    localStorage.workspace = this.$route.params.wsid
    window.workspaceLink = true

    if (this.userId){
        this.$router.push('/dashboard/' + localStorage.lastDash)

    } else {
      this.$router.push('/auth')

    }


  




  }

  
}
</script>
